import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { resource } from '@util/resource/resource';
import { NotificationService } from './notification.service';

export type MessageBannerInteractionAction = 'CTA_CLICK' | 'DISMISS' | 'READ';

@Injectable({
  providedIn: 'root',
})
export class NotificationMessageLogService {
  constructor(private readonly notifications: NotificationService) {}

  log(notificationId: string, actionType: MessageBannerInteractionAction): Observable<unknown> {
    return resource('crm://notification/messages/interaction-log').post({
      notificationId,
      actionType,
    });
  }

  /** Persists DISMISS + viewed_at on server, then updates local messages and top-banner shell state. */
  dismissBanner(notificationId: string): Observable<unknown> {
    return this.log(notificationId, 'DISMISS').pipe(
      tap(() => this.notifications.markMessageBannerDismissedLocally(notificationId))
    );
  }
}
